runOnLoad "Subscribers", [ "show" ], ->

  $(document).on "change", "#show_duplicate_opens", ->

    mailingListId = $("#mailing_list_id").val()
    subscriberId  = $("#subscriber_id").val()
    show_dups     = if $(@).is(":checked") then "1" else "0"
    params        = { "show_duplicate_opens": show_dups }

    $.getScript Routes.mailing_list_subscriber_path(mailingListId, subscriberId, params)
